import { jsx as _jsx, jsxs as _jsxs } from "nativewind/jsx-runtime";
import React, { useState } from 'react';
import styled from 'styled-components/native';
import { ScreenLayout } from '@/components/ScreenLayout';
import V2TabBar from '@/screens/PlaceDetailV2Screen/components/V2TabBar';
import SavedContentsTab from './components/SavedContentsTab';
import SavedPlaceListsTab from './components/SavedPlaceListsTab';
const TAB_ITEMS = [
    { value: 'PLACES', label: '저장한 장소' },
    { value: 'CONTENTS', label: '저장한 컨텐츠' },
];
export default function MySavesScreen() {
    const [currentTab, setCurrentTab] = useState('PLACES');
    return (_jsxs(ScreenLayout, { isHeaderVisible: true, children: [_jsx(V2TabBar, { items: TAB_ITEMS, current: currentTab, onChange: setCurrentTab }), _jsx(TabContent, { children: currentTab === 'PLACES' ? (_jsx(SavedPlaceListsTab, {})) : (_jsx(SavedContentsTab, {})) })] }));
}
const TabContent = styled.View `
  flex: 1;
`;
